import React from "react";
import styled from "styled-components";
import TickIconPNG from "../../../../assets/Icons/tick.png";
import { SubscriptionType } from "../../../../Data/subscription.dto";
import CancelIconPNG from "../../../../assets/Icons/cancelIcon.png";
import SelectedTickIconPNG from "../../../../assets/Icons/subscription/tick.png";
import SelectedCancelIconPNG from "../../../../assets/Icons/subscription/cancel.png";
import LeftElipseSVG from "../../../../assets/Icons/subscription/left_elipse.svg";
import RightElipseSVG from "../../../../assets/Icons/subscription/right_elipse.svg";
import { device } from "../../Utlis/media";
interface CardProps {
  card: SubscriptionType;
  currentPlanId?: number;
  isActivated: boolean;
  onClick1: (id: number) => void;
  setDurationPopup: (boolean: boolean) => void;
}
const CardContainer = styled.div<{ isActivated: boolean }>`
  width: 280px;
  padding-bottom: 20px;
  position: relative;
  overflow: hidden;
  background-color: #f7f7f7;
  /* border: 1px solid gray; */
  height: 500px;

  border-radius: 25px;
  ${(props) =>
    props.isActivated
      ? `
     transform: translateY(-10px);
     
    transition: all 0.4s ease-in-out;
    background: linear-gradient(144.01deg, rgba(255, 201, 81, 0.8) 0%, rgba(206, 86, 176, 0.8) 100%);
    `
      : null}

  > * {
    position: relative;
    z-index: 1;
  }

  @media ${device.tablet} {
    width: 100%;
    margin-left: 0;
  }
`;

const SelectedDecorationLayer = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
`;

const LeftElipse = styled.img`
  position: absolute;
  top: 28%;
  left: -19%;
`;

const RightElipse = styled.img`
  position: absolute;
  top: 20%;
  right: -8%;
  width: 190px;
`;
const RecommendedButton = styled.div<{ isActivated: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  ${(props) => (!props.isActivated ? `display:none;` : null)}
  width: 100%;
  // min-width: 121px;
  height: 27px;
  background: linear-gradient(144.01deg, rgba(255, 201, 81, 0.8) 0%, rgba(206, 86, 176, 0.8) 100%);
  color: white;
  margin-top: -27px;
  // margin-right: 10px;
  text-align: center;
  border-radius: 6px;
  opacity: 0.9;
  padding: 3px 10px;
  font-family: Urbanist;
  font-size: 16px;
  font-weight: 800;
  line-height: 12px;
  letter-spacing: 0.8333333134651184px;
`;
const RecommendedContainer = styled.div`
  display: flex;
  // position: absolute;
  // right: -6px;
  align-items: center;
  justify-content: center;
`;

const CardHeader = styled.div<{ isActivated: boolean }>`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 25px;
  width: 88%;
  margin: 15px;
  /* color: ${(props) => (props.isActivated ? "" : "#1D1D1D")};
  margin-top: ${(props) => (props.isActivated ? "15px" : "15px")}; */

  ${(props) =>
    props.isActivated ? `background: rgba(255, 255, 255, 0.2)` : null}
`;

const TeamMember = styled.p<{ isActivated: boolean }>`
  font-family: "Urbanist";
  font-size: 17px;
  font-weight: 600;
  height: 24px;
  text-align: center;
  color: #696969;
  color: ${(props) => (props.isActivated ? `white` : `""`)};
`;

const CardStorage = styled.p<{ isActivated: boolean }>`
  font-family: "Urbanist";
  font-size: 17px;
  font-weight: 600;
  text-align: center;
  color: #696969;
  color: ${(props) => (props.isActivated ? `white` : `""`)};
`;

const CardPrice = styled.p<{ isActivated: boolean }>`
  font-family: "Urbanist";
  font-size: 16px;
  font-weight: 800;
  line-height: 20.4px;
  text-align: left;
  margin: 0px;
  color: ${(props) => (props.isActivated ? `white` : `""`)};
`;
const CardMonth = styled.span<{ isActivated: boolean }>`
  font-size: 12px;
  font-weight: 500;
  color: #696969;
  color: ${(props) => (props.isActivated ? `white` : `""`)};
`;

const CardYear = styled.span<{ isActivated: boolean }>`
  font-size: 12px;
  font-weight: 500;
  color: #696969;
  color: ${(props) => (props.isActivated ? `white` : `""`)};
`;

const CardYearPrice = styled.p<{ isActivated: boolean }>`
  font-family: "Urbanist";
  font-size: 16px;
  font-weight: 800;
  line-height: 20.4px;
  text-align: left;
  margin: 0px;
  color: ${(props) => (props.isActivated ? `white` : `""`)};
`;

const PlanType = styled.p`
  font-family: "Urbanist";
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  line-height: 26px;
  text-align: left;
  margin: 10px 0px;
`;
const CardDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  margin-left: 15px;
  margin-top: 10px;
`;
const DescriptionItemContainer = styled.div`
  display: flex;
  margin-top: 18px;
  align-items: center;
`;
const ItemIcon = styled.img`
  width: 20px;
  height: 20px;
`;

const CancelIcon = styled.img`
  width: 20px;
  height: 20px;
`;
const SelectedPointIcon = styled.img`
  width: 20px;
  height: 20px;
`;
const DescriptionItem = styled.p<{ isActivated: boolean }>`
  font-family: "Urbanist";
  font-size: 15px;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
  margin: 0px;
  margin-left: 10px;

  color: ${(props) => (props.isActivated ? `white` : `#696969`)};

  ${(props) =>
    props.isActivated
      ? `
    font-family: Urbanist;
    font-weight: 600;
    font-style: normal;
    line-height: 100%;
    letter-spacing: 0;
    vertical-align: middle;
    color: rgba(255, 255, 255, 1);
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 999px;
  `
      : `
    font-family: Urbanist;
    font-weight: 600;
    font-style: normal;
    line-height: 100%;
    letter-spacing: 0;
    vertical-align: middle;
    color: rgba(105, 105, 105, 1);
  `}
`;

const AddOnItemContainer = styled.div`
  display: flex;
  margin-top: 18px;
  align-items: center;
  padding: 6px 0;
  border-top: 1px dashed rgba(0, 0, 0, 0.15);
`;

const AddOnItem = styled.p<{ isActivated: boolean }>`
  font-family: "Urbanist";
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  text-align: left;
  margin: 0px;
  margin-left: 10px;
  color: ${(props) => (props.isActivated ? `rgba(255,255,255,0.95)` : `#C94DAA`)};
`;
const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const SubmitButton = styled.button<{ isActivated: boolean }>`
  width: 120px;
  height: 40px;
  padding: 10px 20px;
  margin-bottom: 10px;
  border: none;
  border-radius: 20px;
  font-family: "Urbanist";
  font-size: 15px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
  cursor: pointer;
  background: linear-gradient(144.01deg, rgba(255, 201, 81, 0.8) 0%, rgba(206, 86, 176, 0.8) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => (props.isActivated ? `white` : ``)};
`;

const GradientText = styled.span<{ isActivated: boolean }>`
  background: linear-gradient(144.01deg, rgba(255, 201, 81, 0.8) 0%, rgba(206, 86, 176, 0.8) 100%);
  -webkit-background-clip: text;
  font-size: 24px;
  font-family: "Urbanist";
  font-weight: 800;
  background-clip: text;
  color: #ffffff;
  color: ${(props) => (props.isActivated ? `black` : ``)};
`;

const CanceledText = styled.span`
  text-decoration: line-through;
`;

export const STATIC_PLANS = [
  {
    button: "Studio",
    name: "Studio Plan",
    monthly: 1499,
    yearly: 14999,
    teamMembers: 1,
    storage: "100 GB",
    features: {
      "Client App": true,
      "Proposal Tool": true,
      "Admin Dashboard": true,
      "Standard Support": true,
      "White-label Branding": false,
      "Team management": false,
      "Calendar management": false,
    },
  },
  {
    button: "PRO",
    name: "Pro plans",
    monthly: 2999,
    yearly: 29999,
    teamMembers: 20,
    storage: "300 GB",
    features: {
      "Client App": true,
      "Admin Dashboard": true,
      "Team management": true,
      "Calendar management": true,
      "Proposal Tool": true,
      "Priority Support": true,
      "White-label Branding": false,
    },
  },
  {
    button: "Business",
    name: "Business Plans",
    monthly: 4999,
    yearly: 49999,
    teamMembers: 50,
    storage: "1 TB",
    features: {
      "Client App": true,
      "Priority Support": true,
      "Admin Dashboard": true,
      "Team management": true,
      "Calendar management": true,
      "Proposal Tool": true,
      "White-label Branding": true,
    },
  },
];

const SubscriptionCard: React.FC<CardProps> = ({
  card,
  isActivated,
  onClick1,
  setDurationPopup,
  currentPlanId,
}) => {
  const StaticPlans = STATIC_PLANS;

  const currentPlan = StaticPlans.find(
    (pl) =>
      pl.name?.toLowerCase() === String(card.description ?? "").toLowerCase()
  );

  const isProPlan = currentPlan?.name === "Pro plans";

  const formatToINR = (amount: number): string => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  };

  return (
    <CardContainer isActivated={isActivated} onClick={() => onClick1(card.id)}>
      {isActivated && (
        <SelectedDecorationLayer>
          <LeftElipse src={LeftElipseSVG} alt="" aria-hidden />
          <RightElipse src={RightElipseSVG} alt="" aria-hidden />
        </SelectedDecorationLayer>
      )}
      <RecommendedContainer>
        {currentPlanId && currentPlanId === card.id ? (
          <RecommendedButton isActivated={true}>Current</RecommendedButton>
        ) : isProPlan ? (
          <RecommendedButton isActivated={true}>
            <span aria-hidden>★</span> Most Popular
          </RecommendedButton>
        ) : (
          <RecommendedButton isActivated={card.description === "MOST POPULAR"}>
            Recommended
          </RecommendedButton>
        )}
      </RecommendedContainer>

      <CardHeader isActivated={isActivated}>
        <div className="p-3 w-[230px] rounded-lg">
          <ButtonContainer>
            <SubmitButton
              isActivated={isActivated}
              onClick={(e) => {
                !isActivated ? onClick1(card.id) : setDurationPopup(true);
              }}
            >
              <GradientText
                isActivated={isActivated}
                className="style-extrabold"
              >
                {currentPlan ? currentPlan.button : "CHOOSE PLAN"}
              </GradientText>
            </SubmitButton>
          </ButtonContainer>

          <div className="flex gap-5">
            <CardPrice isActivated={isActivated}>
              {formatToINR(card.offer_price)}{" "}
              <CardMonth isActivated={isActivated}>/Month</CardMonth>
            </CardPrice>
            <CardYearPrice isActivated={isActivated}>
              {formatToINR(Number(card.storage_price_per_year ?? 0))}{" "}
              <CardYear isActivated={isActivated}>/year</CardYear>
            </CardYearPrice>
          </div>

          <TeamMember isActivated={isActivated}>
            {/* Team Member -1 */}
            Team Member - {currentPlan?.teamMembers ?? 1}
          </TeamMember>

          <CardStorage isActivated={isActivated}>
            {card.storage_size}
          </CardStorage>
        </div>
      </CardHeader>

      <CardDescriptionContainer>
        {Object.entries(
          StaticPlans.find(
            (pl) =>
              pl.name?.toLowerCase() ===
              String(card.description ?? "").toLowerCase()
          )?.features ?? {}
        ).map(([key, value]) => (
          <DescriptionItemContainer key={key}>
            {!value ? (
              <SelectedPointIcon
                src={isActivated ? SelectedCancelIconPNG : CancelIconPNG}
                alt=""
                aria-hidden
              />
            ) : (
              <SelectedPointIcon
                src={isActivated ? SelectedTickIconPNG : TickIconPNG}
                alt=""
                aria-hidden
              />
            )}
            <DescriptionItem isActivated={isActivated}>{key}</DescriptionItem>
          </DescriptionItemContainer>
        ))}
        {/* {isProPlan && (
          <AddOnItemContainer>
            <ItemIcon src={TickIconPNG} />
            <AddOnItem isActivated={isActivated}>
              +Add-on : White-labeling
            </AddOnItem>
          </AddOnItemContainer>
        )} */}
        {/* <DescriptionItemContainer>
                    <ItemIcon src={TickIconPNG} />
                    <DescriptionItem isActivated={isActivated}>
                        {card.project_limit} Albums
                    </DescriptionItem>
                </DescriptionItemContainer>
                <DescriptionItemContainer>
                    <ItemIcon src={TickIconPNG} />

                    <DescriptionItem isActivated={isActivated}>
                        Share  to {card.user_limit} People
                    </DescriptionItem>
                </DescriptionItemContainer>
                <DescriptionItemContainer>
                    {!card.event_management ? <CancelIcon src={CancelIconPNG} /> : <ItemIcon src={TickIconPNG} />}

                    <DescriptionItem isActivated={isActivated}>
                        Event Scheduling
                    </DescriptionItem>
                </DescriptionItemContainer>
                <DescriptionItemContainer>
                    {!card.packages ? <CancelIcon src={CancelIconPNG} /> : <ItemIcon src={TickIconPNG} />}

                    <DescriptionItem isActivated={isActivated}>
                        Studio Packages
                    </DescriptionItem>
                </DescriptionItemContainer>
                <DescriptionItemContainer>
                    {!card.user_form ? <CancelIcon src={CancelIconPNG} /> : <ItemIcon src={TickIconPNG} />}

                    <DescriptionItem isActivated={isActivated}>
                        Customer Event Management
                    </DescriptionItem>
                </DescriptionItemContainer>
                <DescriptionItemContainer>
                    {!card.enable_watermark ? <CancelIcon src={CancelIconPNG} /> : <ItemIcon src={TickIconPNG} />}

                    <DescriptionItem isActivated={isActivated}>
                        Water mark feature
                    </DescriptionItem>
                </DescriptionItemContainer>
                <DescriptionItemContainer>
                    {!card.enable_watermark ? <CancelIcon src={CancelIconPNG} /> : <ItemIcon src={TickIconPNG} />}

                    <DescriptionItem isActivated={isActivated}>
                        Water mark feature
                    </DescriptionItem>
                </DescriptionItemContainer> */}
      </CardDescriptionContainer>
      {/* <ButtonContainer>
        <SubmitButton
          isActivated={isActivated}
          onClick={(e) => {
            !isActivated ? onClick1(card.id) : setDurationPopup(true);
          }}
        >
          <GradientText>Choose Plan</GradientText>
        </SubmitButton>
      </ButtonContainer> */}
    </CardContainer>
  );
};

export default SubscriptionCard;
